import { PFBAutopay,CheckLQ } from './../constants/actionType'
let currentDate = new Date();
let currentMonth = currentDate.getMonth() + 1;
if (Number(currentMonth) < 10) {
    currentMonth = '0' + currentMonth;
}
let currentYear = currentDate.getFullYear();
const initialState = {
    isInitialStatus: true,
    isPFBContinue: false,
    isPFBTOSContinue: false,
    isPFBInfo: {
        isValidEmail: false,
        pfbemailid: "",
        pfbemailError: "",
    },
    pfbChecked:true,
    autopayChecked:true,
    pfbUnCheckedContinue:false,
    onPFBProfileVerified:false,
    pfbTosAgree:"",
    autopayTosAgree:"",
    autopayPFBTosAgree:"",
    isPFBEnrolled: false,
    //AUTOPAY Start Here
    isAutoPay: true,
    checkingsavingsAccount: {
        isCheckingAccount: false,
        isSavingsAccount: false,
        routingNumber: "",
        routingNumber_format:"",
        accountNumber: "",
        accountNumber_format:"",
        nickName: "",
        isRoutingNumberValid : true,
        isAccountNumberValid : true
    },
    creditDebitAccount: {
        isCreditAccount: false,
        isDebitAccount: false,
        firstName: "",
        lastName: "",
        cardNumber: "",
        cardNumber_format:"",
        cardtype: "",
        cardnickname: "",
        expirationDate: {
            Month: String(currentMonth),
            Year: String(currentYear)
        },
        expiryDate: "",
        CVVNumber: "",
        isCardNumberValid : true,
    },
    cvvMaxLength:"3",
    paymentmodeSelection: PFBAutopay.onPaymentMode.onChecking,
    isVEPSCall: {
        isAutoPayEnrolled: false,
        errorMessage: "",
        displayMessage: "",
        discription:"",
        apoDiscountEligiblePmtMethod: false,
    },
    autoPayType: "",
    bankAccountType: "",
    isAutopayFormSaved: false,
    isShowPaymentAlertBanner :false,
    focusAlertBanner:false,
    enablePFBautoPayReskin: true,
    isVerizonVisaCC: false,
    //CBA Start Here
    ischangeBillingSave: false,
    changeBillingAddress: {
        streetName: "",
        unitType: "",
        unit: "",
        city: "",
        state: "",
        zipcode: "",
        streetErr:false,
        cityErr:false,
        stateErr:false,
        zipErr:false,
    },
    ischangeBillingContinue: false,
    isPFBAutopayEnrolled: false,
    isCreditPayment: false,
    lofOptionValue:"",
    lofAutopayClicked:false,
    lofTosEnable:false,
    lofSuccess:false,
    lofResubmit:false,
    lofStatusAttempts: 0,
    lofChecked:false,
    lofAutoPayRequest:null,
    mnhAutoPayCheckbox:"yes",
    showMnhAutoPay:true,
    verifyPfbEmailLoader:false
};

function pfbautopay(state = initialState, action) {
    switch (action.type) {
        case PFBAutopay.onPFBClick:
            if (action.value === PFBAutopay.onPFB) {
                return Object.assign({}, state, {
                    isPFBContinue: !state.isPFBContinue,
                })
            }
            
            if (action.value === PFBAutopay.onPFBTosContinue) {
                // let pfbEnrolled = Object.assign({}, state, {
                //     isPFBTOSContinue: !state.isPFBTOSContinue,
                //     isPFBEnrolled: !state.isPFBEnrolled,
                // })
                return Object.assign({}, state, {
                    isPFBTOSContinue: !state.isPFBTOSContinue
                })
            }
            break;
        case PFBAutopay.onPaymentModeChange:
            return Object.assign({}, state, {
                paymentmodeSelection: action.value
            })
        case PFBAutopay.autoPayType:
           return Object.assign({}, state, {
                 autoPayType: action.value
                })
        case PFBAutopay.bankAccountType:
            return Object.assign({}, state, {
                bankAccountType: action.value
                })  
        case PFBAutopay.isAutopayFormSaved:
            return Object.assign({}, state, {
                isAutopayFormSaved: action.value
            })
        case PFBAutopay.isShowPaymentAlertBanner:
            return Object.assign({}, state, {
                isShowPaymentAlertBanner: action.value
            })
        case PFBAutopay.focusAlertBanner:
            return Object.assign({}, state, {
                focusAlertBanner: action.value
            })  
        case PFBAutopay.isVerizonVisaCC:
               return Object.assign({}, state, {
                   isVerizonVisaCC: action.value
                         }) 
        case PFBAutopay.enablePFBautoPayReskin:
           return Object.assign({}, state, {
            enablePFBautoPayReskin: action.value
                }) 
        case PFBAutopay.PFBChecked:
            return Object.assign({}, state, {
                pfbChecked: action.value
            })
        case "AP_CVVMAXLENGTH":
            let cvupdate = Object.assign({}, state.creditDebitAccount, {
                CVVNumber: ''
            })

            return Object.assign({}, state, {
                creditDebitAccount: cvupdate,
                cvvMaxLength: action.value
            })
        case PFBAutopay.autopayChecked:
            return Object.assign({}, state, {
                autopayChecked: action.value
            })
        case PFBAutopay.pfbUnCheckedContinue:
            return Object.assign({}, state, {
                pfbUnCheckedContinue: action.value
            })
        case PFBAutopay.pfbTosAgree:
            return Object.assign({}, state, {
                pfbTosAgree: action.value
            })
        case PFBAutopay.autopayTosAgree:
            return Object.assign({}, state, {
                autopayTosAgree: action.value
            })
        case PFBAutopay.autopayPFBTosAgree:
            return Object.assign({}, state, {
                autopayPFBTosAgree: action.value
        })
        case PFBAutopay.onCheckAutoPayOffer:
            return Object.assign({}, state, {
                isAutoPay: action.value
            })
        case PFBAutopay.onCreditPayment:
            return Object.assign({}, state, {
                isCreditPayment: action.value
            })
        case PFBAutopay.onPFBProfileVerified:
            return Object.assign({}, state, {
                onPFBProfileVerified: action.value
            })    
        case PFBAutopay.onupdateEmailID:
            let pfbemailInfo = Object.assign({}, state.isPFBInfo, {
                pfbemailid: action.value,
                pfbemailError: "",
                isValidEmail: true
            })
            return Object.assign({}, state, {
                isPFBInfo: pfbemailInfo,
            })
        case PFBAutopay.onValidatePFB:
            let pfbInfo = Object.assign({}, state.isPFBInfo, {
                pfbemailid: action.value.eMailId || action.value.PFBeMailId,
                pfbemailError: action.value.eMailErr || action.value.PFBeMailErr,
                isValidEmail: action.value.isValidMail
            })
            return Object.assign({}, state, {
                isPFBInfo: pfbInfo,
            })
        case  "VERIFY_PFB_EMAIL_EC_LOADER":
            return{
                ...state,
                verifyPfbEmailLoader:!state.verifyPfbEmailLoader
            } 
        case "RESET_TOS_VALUE":
            return{
                ...state,
                isPFBTOSContinue: state.isPFBTOSContinue ? state.isPFBContinue : false  // added condition, on refreshing of page, value is setting to false
         } 
        case "ONLY_AUTOPAY_ENROLLED_ONPROFILE":
            let vepsObj = Object.assign({}, state.isVEPSCall, {
                isAutoPayEnrolled: action.value,
            })
            return Object.assign({}, state, {
                isVEPSCall: vepsObj
            })
                   
        case PFBAutopay.onValidateAutoPay:
            if ([PFBAutopay.onPaymentMode.onSavings, PFBAutopay.onPaymentMode.onChecking, PFBAutopay?.onPaymentMode?.onBank]?.includes(state.paymentmodeSelection)) {
                const routingNumber =  action.value.routingNumber !== undefined && action.value.routingNumber !== state.checkingsavingsAccount.routingNumber !== "" ? action.value.routingNumber : state.checkingsavingsAccount.routingNumber;//action.value.routingNumber || state.checkingsavingsAccount.routingNumber;
                const accountNumber =  action.value.bankAccountNumber !== undefined && action.value.bankAccountNumber !== state.checkingsavingsAccount.accountNumber !== "" ? action.value.bankAccountNumber : state.checkingsavingsAccount.accountNumber;//action.value.bankAccountNumber || state.checkingsavingsAccount.accountNumber;
                const isRoutingNumberValid = state?.enablePFBautoPayReskin ? !!(routingNumber?.length === 9|| routingNumber?.length === 0)  :  !!(routingNumber.length === 9)
                const isAccountNumberValid = state?.enablePFBautoPayReskin ? !!(accountNumber?.length > 5 || accountNumber?.length === 0) : !!(accountNumber.length > 5)
                let checkingsavings = Object.assign({}, state.checkingsavingsAccount, {
                    isCheckingAccount: (state.paymentmodeSelection === PFBAutopay.onPaymentMode.onChecking || state.bankAccountType==="Checking") ? true : false,
                    isSavingsAccount: (state.paymentmodeSelection === PFBAutopay.onPaymentMode.onSavings  || state.bankAccountType==="Savings")? true : false,
                    routingNumber,
                    routingNumber_format: action.value.routingNumber_format !== undefined && action.value.routingNumber_format !== state.checkingsavingsAccount.routingNumber_format !== "" ? action.value.routingNumber_format : state.checkingsavingsAccount.routingNumber_format,
                    accountNumber,
                    accountNumber_format: action.value.bankAccountNumber_format !== undefined && action.value.bankAccountNumber_format !== state.checkingsavingsAccount.accountNumber_format !== "" ? action.value.bankAccountNumber_format : state.checkingsavingsAccount.accountNumber_format,
                    nickName: action.value.nickName !== undefined && action.value.nickName !== state.checkingsavingsAccount.nickName !== "" ? action.value.nickName : state.checkingsavingsAccount.nickName,
                    isRoutingNumberValid,
                    isAccountNumberValid

                })
                return Object.assign({}, state, {
                    checkingsavingsAccount: checkingsavings,
                })
            }
            else if (state.paymentmodeSelection === PFBAutopay.onPaymentMode.onCredit ||
                state.paymentmodeSelection === PFBAutopay.onPaymentMode.onDebit) {
                    const cardNumber = action.value.cardNumber !== undefined &&
                    action.value.cardNumber !== state.creditDebitAccount.cardNumber !== "" ? action.value.cardNumber : state.creditDebitAccount.cardNumber;
                let creditdebit = Object.assign({}, state.creditDebitAccount, {
                    isCreditAccount: state.paymentmodeSelection === PFBAutopay.onPaymentMode.onCredit ? true : false,
                    isDebitAccount: state.paymentmodeSelection === PFBAutopay.onPaymentMode.onDebit ? true : false,
                    firstName: action.value.firstName !== undefined &&
                        action.value.firstName !== state.creditDebitAccount.firstName !== "" ? action.value.firstName : state.creditDebitAccount.firstName,
                    lastName: action.value.lastName !== undefined &&
                        action.value.lastName !== state.creditDebitAccount.lastName !== "" ? action.value.lastName : state.creditDebitAccount.lastName,
                    cardNumber,
                    cardNumber_format: action.value.cardNumber_format !== undefined &&
                        action.value.cardNumber_format !== state.creditDebitAccount.cardNumber_format !== "" ? action.value.cardNumber_format : state.creditDebitAccount.cardNumber_format,
                    cardtype: action.value.cardType !== undefined &&
                        action.value.cardType !== state.creditDebitAccount.cardtype !== "" ? action.value.cardType : state.creditDebitAccount.cardtype,
                    cardnickname: action.value.cardNickName !== undefined &&
                        action.value.cardNickName !== state.creditDebitAccount.cardnickname !== "" ? action.value.cardNickName : state.creditDebitAccount.cardnickname,
                    expirationDate: {
                        Month: action.value.expirationDate !== undefined &&
                            action.value.expirationDate !== state.creditDebitAccount.expirationDate.Month !== "" ? action.value.expirationDate : state.creditDebitAccount.expirationDate.Month,
                        Year: action.value.expirationDateYear !== undefined &&
                            action.value.expirationDateYear !== state.creditDebitAccount.expirationDate.Year !== "" ? action.value.expirationDateYear : state.creditDebitAccount.expirationDate.Year,
                        
                    },
                    expiryDate: action.value.expiryDate !== undefined ?  action.value.expiryDate : state.creditDebitAccount.expiryDate,
                    CVVNumber: action.value.cvv !== undefined &&
                        action.value.cvv !== state.creditDebitAccount.CVVNumber !== "" ? action.value.cvv : state.creditDebitAccount.CVVNumber,
                    isCardNumberValid : !!(cardNumber.length > 13),

                })
                return Object.assign({}, state, {
                    creditDebitAccount: creditdebit,
                })
            }
            break;
        case PFBAutopay.onupdateFNameLName:
            let fNamelName = Object.assign({}, state.creditDebitAccount, {
                isCreditAccount: false,
                isDebitAccount: false,
                firstName: action.firstName,
                lastName: action.lastName,
                cardNumber: "",
                cardtype: "",
                cardnickname: "",
                expirationDate: {
                    Month: typeof currentMonth === 'string' ?  currentMonth: JSON.stringify(currentMonth),
                    Year: typeof currentYear === 'string' ?  currentYear : JSON.stringify(currentYear)
                },
                CVVNumber: ""
            })
            return Object.assign({}, state, {
                creditDebitAccount: fNamelName,
            })
        case PFBAutopay.onClearCard:
        if (action.value === PFBAutopay.onCheckingSavingAC) {
            let clearcheckingsavingAC = Object.assign({}, state.checkingsavingsAccount, {
                isCheckingAccount: false,
                isSavingsAccount: false,
                routingNumber: "",
                routingNumber_format: "",
                accountNumber: "",
                accountNumber_format:"",
                nickName: "",
                isRoutingNumberValid : true,
                isAccountNumberValid : true
            })
            return Object.assign({}, state, {
                checkingsavingsAccount: clearcheckingsavingAC,
            })
        }
        else if (action.value === PFBAutopay.onCreditDebitAC) {
            let clearcreditdebitAC = Object.assign({}, state.creditDebitAccount, {
                isCreditAccount: false,
                isDebitAccount: false,
                firstName: "",
                lastName: "",
                cardNumber: "",
                cardNumber_format: "",
                cardtype: "",
                cardnickname: "",
                expirationDate: {
                    Month: String(currentMonth),
                    Year: String(currentYear)
                },
                expiryDate: "",
                CVVNumber: "",
                isCardNumberValid : true,
            })
            return Object.assign({}, state, {
                creditDebitAccount: clearcreditdebitAC,
            })
        }
        else if (action.value === PFBAutopay.creditDebitAccount) {
            let creditDebitAccount = Object.assign({}, state.creditDebitAccount, {
                isCreditAccount: false,
                isDebitAccount: false,
                firstName: "",
                lastName: "",
                cardNumber: "",
                cardNumber_format:"",
                cardtype: "",
                cardnickname: "",
                expirationDate: {
                    Month: String(currentMonth),
                    Year: String(currentYear)
                },
                expiryDate: "",
                CVVNumber: "",
                isCardNumberValid : true
                    })
                    return Object.assign({}, state, {
                        creditDebitAccount: creditDebitAccount
                    })
        }
            break;
        case "CO_VEPSCALL":
            let displayMessage = action.value.displayMessage !== undefined ? action.value.displayMessage : "";
            displayMessage = (action.value.message && action.value.message.toLowerCase().indexOf('routing') > -1 ) ? displayMessage.concat (' ').concat('Routing number is invalid') : displayMessage;
            let vepsCall = Object.assign({}, state.isVEPSCall, {
                isAutoPayEnrolled: action.value.status?.toLowerCase() === PFBAutopay.onAPIResponseCheck.onSuccess ? true : false,
                errorMessage: action.value.message !== undefined ? action.value.message : "",
                displayMessage,
                discription:action.value.description !== undefined ? action.value.description : "", //Even VEPS Server itself Down will get this message
                apoDiscountEligiblePmtMethod: action.value?.apoDiscountEligiblePmtMethod?.toUpperCase() === "Y"
            })
            return Object.assign({}, state, {
                isVEPSCall: vepsCall,
            })
        case CheckLQ.MNHPFBAUTOPAY:
            let mnhVepsCall = Object.assign({}, state.isVEPSCall, {
                isAutoPayEnrolled: action.value,
                errorMessage:"",
                discription: "",
                
            })
            return Object.assign({}, state, {
                isVEPSCall: mnhVepsCall,
        })
        case "RESET_DESCRIPTION" :
            let vepsCallObj = Object.assign({}, state.isVEPSCall,{
                discription:'',
                displayMessage: ''
            });
            return Object.assign({}, state, {
                isVEPSCall: vepsCallObj,
            })
        case PFBAutopay.onValidateCBA:
            let validatecba = Object.assign({}, state.changeBillingAddress, {
                streetName: action.value.streetName !== undefined && action.value.streetName !== state.changeBillingAddress.streetName !== "" ? action.value.streetName : state.changeBillingAddress.streetName,
                unitType: action.value.unitType !== undefined && action.value.unitType !== state.changeBillingAddress.unitType !== "" ? action.value.unitType : state.changeBillingAddress.unitType,
                unit: action.value.UnitNo !== undefined && action.value.UnitNo !== state.changeBillingAddress.unit !== "" ? action.value.UnitNo : state.changeBillingAddress.unit,
                city: action.value.city !== undefined && action.value.city !== state.changeBillingAddress.city !== "" ? action.value.city : state.changeBillingAddress.city,
                state: action.value.state !== undefined && action.value.state !== state.changeBillingAddress.state !== "" ? action.value.state : state.changeBillingAddress.state,
                zipcode: action.value.zipCode !== undefined && action.value.zipCode !== state.changeBillingAddress.zipcode !== "" ? action.value.zipCode : state.changeBillingAddress.zipcode,
            })
            return Object.assign({}, state, {
                changeBillingAddress: validatecba,
            })
        case PFBAutopay.onCBASave:
            return Object.assign({}, state, {
                ischangeBillingSave: action.value,
            })
        case PFBAutopay.onAutoPayReviewChange:
            let autopayReview = Object.assign({}, state.isVEPSCall, {
                isAutoPayEnrolled: !state.isVEPSCall.isAutoPayEnrolled,
                errorMessage: action.value.message !== undefined ? "" : "",
                displayMessage: action.value.displayMessage !== undefined ? "" : ""
            })
            return Object.assign({}, state, {
                isVEPSCall: autopayReview,
            })
        case PFBAutopay.onPFBAutoPayStatus:
            return Object.assign({}, state, {
                isPFBAutopayEnrolled: state.isPFBTOSContinue && state.isVEPSCall.isAutoPayEnrolled ? true : false,
                // isPFBAutopayEnrolled: state.isPFBTOSContinue && state.isVEPSCall.isAutoPayEnrolled && state.isVEPSCall.apoDiscountEligiblePmtMethod ? true : false,
            })
        case PFBAutopay.stateErr:
            let stateError = Object.assign({}, state.changeBillingAddress, {
                stateErr: action.value
            })
            return Object.assign({}, state, {
                changeBillingAddress: stateError
            })
        case PFBAutopay.cityErr:
            let cityError = Object.assign({}, state.changeBillingAddress, {
                cityErr: action.value
            })
            return Object.assign({}, state, {
                changeBillingAddress: cityError
            })
        case PFBAutopay.streetErr:
            let streetError = Object.assign({}, state.changeBillingAddress, {
                streetErr: action.value
            })
            return Object.assign({}, state, {
                changeBillingAddress: streetError
            })
        case PFBAutopay.zipErr:
            let zipError = Object.assign({}, state.changeBillingAddress, {
                zipErr: action.value
            })
            return Object.assign({}, state, {
                changeBillingAddress: zipError
            })
        case "LOF_OPTIONCLICK":
            return Object.assign({}, state, {
                lofOptionValue: action.value
            })
        case "LOF_AUTOPAYCLICKED":
            return Object.assign({}, state, {
                lofAutopayClicked: action.value
            })
        case "LOF_RESUBMIT_STATUS":
            return Object.assign({}, state, {
                lofResubmit: action.value,
                lofStatusAttempts: state.lofStatusAttempts + 1,
            })
        case "LOF_TOSENABLE":
            return Object.assign({}, state, {
                lofTosEnable: action.value
            })
        case "LOF_SUCCESS":
            return Object.assign({}, state, {
                lofSuccess: action.value
            })
        case "LOF_CHECKED":
            return Object.assign({}, state, {
                lofChecked: action.value
            })
        case "LOF_AUTOPAYREQUEST":
            return Object.assign({}, state, {
                lofAutoPayRequest: action.value
            })
        case "MNHAUTOPAYCHECKBOX":
            return Object.assign({},state,{
                mnhAutoPayCheckbox:action.value
            }) 
        case "SHOWMNHAUTOPAY":
            return Object.assign({},state,{
                showMnhAutoPay:action.value
            })        
        case "EMPTY_PFBAUTOPAY":
            return initialState
        default:
            return state
    }
}

export default pfbautopay
